const MAX_INTEGER_DIGITS = 13;
const MAX_FRACTION_DIGITS = 2;
const STEP_IN_CENTS = 1;
const MAX_VALUE_IN_CENTS = 999999999999999;

export const sanitizeDecimalInput = (
  value,
  { allowNegative = false, maxFractionDigits = MAX_FRACTION_DIGITS } = {}
) => {
  if (!value) return '';
  const sign =
    allowNegative &&
    String(value)
      .trim()
      .startsWith('-')
      ? '-'
      : '';
  const cleaned = String(value).replace(/[^\d,]/g, '');
  const commaIndex = cleaned.indexOf(',');
  if (commaIndex === -1) return sign + cleaned.slice(0, MAX_INTEGER_DIGITS);

  const integerPart = cleaned.slice(0, commaIndex).slice(0, MAX_INTEGER_DIGITS);
  const fractionPart = cleaned
    .slice(commaIndex + 1)
    .replace(/\D/g, '')
    .slice(0, maxFractionDigits);
  return `${sign}${integerPart},${fractionPart}`;
};

export const parseDecimalInput = (value, options = {}) => {
  const { maxFractionDigits = MAX_FRACTION_DIGITS } = options;
  const sanitized = sanitizeDecimalInput(value, options);
  if (!/\d/.test(sanitized)) return '';
  const scale = 10 ** maxFractionDigits;
  return Math.round(Number(sanitized.replace(',', '.')) * scale) / scale;
};

export const formatDecimalInput = (
  value,
  { maxFractionDigits = MAX_FRACTION_DIGITS } = {}
) => {
  if (value === '' || value === null || value === undefined) return '';
  const number = Number(value);
  if (Number.isNaN(number)) return '';
  if (Number.isInteger(number)) return String(number);
  return number
    .toFixed(maxFractionDigits)
    .replace(/(\.\d{2}\d*?)0+$/, '$1')
    .replace('.', ',');
};

const fractionDigitsOf = number => (String(number).split('.')[1] || '').length;

export const stepDecimalValue = (
  value,
  direction,
  { allowNegative = false } = {}
) => {
  const number = Number(value || 0);
  const scale =
    10 ** Math.max(fractionDigitsOf(number) - MAX_FRACTION_DIGITS, 0);
  const currentInCents = Math.round(number * 100 * scale);
  const nextInCents = currentInCents + direction * STEP_IN_CENTS * scale;
  const limitInCents = MAX_VALUE_IN_CENTS * scale;
  return (
    Math.min(
      Math.max(nextInCents, allowNegative ? -limitInCents : 0),
      limitInCents
    ) /
    (100 * scale)
  );
};

export const sanitizeIntegerInput = value => {
  if (!value) return '';
  return String(value).replace(/\D/g, '');
};
